<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </template>
      </van-nav-bar>
    </div>

    <!-- 循环渲染客服列表 -->
    <div v-for="service in serviceList" :key="service.id" class="servicelistItem">
      <div class="servicelistItemTop">
        <img class="servicelistItemImage" :src="service.avatar">
        <div class="servicelistItemText">{{ service.name }}</div>
        <div class="servicelistItemBtn" @click="toServicePage(service)">
          <div class="servicelistItemBtnText">
            {{ $t("my.contact") }}
          </div>
        </div>
      </div>
      <div class="servicelistItemBottom">
        <div class="servicelistItemInfoText">
          {{ service.serviceTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    serviceList() {
      const base = this.$store.getters.getBaseInfo;
      const list = [];
      // 只有开启客服且主客服链接存在时才显示
      if (base.iskefu == 1 && base.kefu) {
        list.push({
          id: 1,
          name: base.name || this.$t("my.title"),
          avatar: "/img/mine/w.png",
          serviceTime: this.$t("my.service_time"),
          iskefu: 1,
          kefu: base.kefu
        });
      }
      // 如果存在备用客服链接，则添加第二个客服
      if (base.kefu2) {
        list.push({
          id: 2,
          name: base.name || this.$t("my.title"),  // 需要在语言文件中添加对应的 key
          avatar: "/img/mine/fj.png",                    // 可选：单独准备备用客服头像
          serviceTime: this.$t("my.service_time"),
          iskefu: 1,
          kefu: base.kefu2
        });
      }
      return list;
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    toServicePage(service) {
      if (service && service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
      }
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.servicelistItem{
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: 30px 30px;
  margin: 30px 20px;
  border-radius: 20px;
  justify-content: space-between;
  background: linear-gradient(120deg,#212121,#313131);
}
.servicelistItem .servicelistItemTop{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100px;
}
.servicelistItem .servicelistItemTop .servicelistItemImage{
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.servicelistItem .servicelistItemTop .servicelistItemText{
  margin-left: 50px;
  font-size: 43px;
  font-weight: 700;
  color: #e6b98a;
  flex: 1;
}
.servicelistItem .servicelistItemTop .servicelistItemBtn{
  display: flex;
  width: 150px;
  height: 55px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #efcba7, #dcab76);
}
.servicelistItem .servicelistItemTop .servicelistItemBtn .servicelistItemBtnText{
  color: #fff;
  font-size: 25px;
}
.servicelistItem .servicelistItemBottom{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background: rgba(255,255,255,.1);
  border-radius: 10px;
  color: #ccc;
  margin-top: 20px;
}
.servicelistItem .servicelistItemBottom .servicelistItemInfoText{
  font-size: 30px;
}
</style>